<template>
	<ActivityLayout class="kr-type-activity">
		<template #badge>
			<TypeChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				changedBy: activity.changedBy,
				to: activity.to,
				from: activity.from,
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import TypeChangeActivityBadge from "../Activity/TypeChangeActivityBadge.vue";

export default {
	name: "KRTypeActivity",
	components: {
		ActivityLayout,
		TypeChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:String, from:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.KRTypeActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
